<p>{{'jobboard.snippets.paginator.label' | transloco: {pageStart, pageEnd, length} }}</p>
<div class="ct-btn ct-btn-round ct-btn-themed ms-3" (click)="prev();"
  [class.disabled]="jobsService.currentFilter.pageIndex <=0">
  <div class="icon-wrapper">
    <fa-icon [icon]="fontawesomeService.regular.chevronLeft"></fa-icon>
  </div>
</div>
<div class="ct-btn ct-btn-round ct-btn-themed ms-2" (click)="next();" [class.disabled]="reachedEnd">
  <div class="icon-wrapper">
    <fa-icon [icon]="fontawesomeService.regular.chevronRight"></fa-icon>
  </div>
</div>